import Vue from 'vue'
import Vuex from 'vuex'
import getters from './getters'
import common from './modules/common'
import commentList from './modules/commentList'
import customList from './modules/customList'
import downloadStatus from '@/xreports/store/modules/download'
import menus from './modules/menus'
import app from '@/store/modules/app'
import systemUser from '@/store/modules/user'
import commentNPSList from './modules/commentNPSList'
import commentQuality from './modules/commenQuality'

/* 预警详情 */
import warningDetail from '@m/store/modules/warningDetail'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    app,
    systemUser,
    common,
    menus,
    commentList,
    customList,
    downloadStatus,
    warningDetail,
    commentNPSList,
    commentQuality,
  },
  getters,
})
